import React from 'react';

import { clipperDataInitial, ClipperModel } from '../../Models/ClipperModel';

export interface IClipperContextProps {
    clipper: ClipperModel,
    setClipper: (clipper: ClipperModel) => void
}

export const clipperContextInitial: IClipperContextProps = {
    clipper: clipperDataInitial,
    setClipper: () => { ''; }
};

export const ClipperContext = React.createContext(clipperContextInitial);